import './sentry';
import { installStaleChunkReload } from './staleChunkReload';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import { LoginPage } from './auth/LoginPage';
import { AuthCallbackPage } from './auth/AuthCallbackPage';
import { InviteAcceptPage } from './auth/InviteAcceptPage';
import { AuthProvider } from './auth/AuthProvider';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { AdminLanding } from './components/admin/AdminLanding';
import { WelcomePage } from './components/welcome/WelcomePage';
import { queryClient } from './api/queryClient';
import { ThemeSync } from './theme/ThemeSync';

installStaleChunkReload();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeSync />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            {/* SSO landing (SC-2621) — public, like /login. The BE redirects here
                after Google with tokens (or an error) in the URL fragment. */}
            <Route path="/auth/callback" element={<AuthCallbackPage />} />
            {/* Invite accept (SC-2791) — public, outside the authed shell. An
                invited user lands here from the magic link. SSO-first (the
                pending invite is honored by verified email, SC-2796); an email
                + password fallback covers new non-SSO accounts. */}
            <Route path="/invite/accept" element={<InviteAcceptPage />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLanding /></ProtectedRoute>} />
            <Route path="/welcome" element={<ProtectedRoute><WelcomePage /></ProtectedRoute>} />
            <Route path="/*" element={<ProtectedRoute><App /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
